export default "__VITE_ASSET__BG055kPc__"